module.exports = __webpack_public_path__ + "static/media/gradually_launch_mobile_en.623f4d11.png";